//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {apiUrl, apiParams} from '@/const/const'
import MyBtnReturn from '@/components/subComponents/MyBtnReturn'


export default {
    name: 'VoyageResult',
    components: {
        MyBtnReturn,
    },
    data() {
        return {
            tableData: [
                // {
                //   vesselName: '新海秀',
                //   voyage: '1001S',
                //   onboardDate: '2014-11-10', // 开船日期
                //   arrival: '2014-11-29' // 船到日期
                // },
                // {
                //   vesselName: '新海秀',
                //   voyage: '1001S',
                //   onboardDate: '2014-11-10', // 开船日期
                //   arrival: '2014-11-29' // 船到日期
                // },
            ],
            isShowTable: true, // 没有数据时才注释掉这个滚动组件
            isShowLoading: false,
            isShowMore: true,
            canFetch: true, // true代表能继续发送请求，控制getMoreData方法的
            pageSize: 15, // 告知后台一次传回几条表格数据，默认5
            pageNo: 1, // 当前为第几页数据，要累加
            totalCount: 0, // 表格数据总条数，后台返回，计算总页数totalPages
            totalPages: 2, // 总页数，初始化必须比pageNo大
            isNoData: false,
            tableDataUrl: '', // 查询表单数据API，voyageTemplate或voyageTemplateYw
            routeName: '',
        }
    },
    created() {
        document.title = '船期查询';
        let query = this.$route.query;
        this.routeName = query.routeName;
        if (this.routeName === 'VoyageKehu') {
            this.tableDataUrl = apiUrl.voyageTemplate
        } else {
            this.tableDataUrl = apiUrl.voyageTemplateYw
        }
        this.onScrollBottom()
    },
    methods: {
        getMoreData(url, data) {
            // 还要先判断到了最后一页了没
            if (this.pageNo > this.totalPages) {
                this.canFetch = true; // 要恢复可以获取状态，可继续提示暂无更多数据
                this.isShowLoading = false;
                this.isShowMore = false;
                this.showToast('暂无更多数据！', 2000);
                return
            }
            // 调用接口获取数据
            this.requestApi({
                url: url,
                data: data
            }, (resultData) => {
                let dataObj = resultData.data.page;
                let resultArr = dataObj.result || []; // 防止后台返回null
                if (this.pageNo === 1 && resultArr.length === 0) {
                    // 如果根本没有数据
                    this.isShowTable = false;
                    this.isNoData = true;
                    this.isShowLoading = false;
                    this.isShowMore = false;
                    return
                }
                resultArr.forEach((item) => {
                    this.tableData.push(item)
                }); // 表格数据是放在result中
                this.totalCount = dataObj.totalCount;
                this.totalPages = dataObj.totalPages;
                this.pageNo++;
                this.$nextTick(() => {
                    this.$refs.scrollerBottom.reset()
                }) // 要重置scroller组件
            }, (error) => {
                this.isShowLoading = false;
                this.canFetch = true;
                if (error) {
                    console.error(error); // 请求出错时，在这里log比较好，才能立即找到是哪个函数出错
                }
            })
        },
        onScrollBottom() {
            if (!this.canFetch) {
            } else {
                this.isShowLoading = true;
                // this.isShowMore = false
                this.canFetch = false;
                let query = this.$route.query;
                let data = {
                    place_loading: query.place_loading || '',
                    place_delivery: query.place_delivery || '',
                    pageSize: this.pageSize, // 告知后台一次传回几条表格数据，默认5
                    pageNo: this.pageNo, // 当前为第几页数据，要累加
                    openId: apiParams.openId,
                    companyId: apiParams.companyId,
                    code: apiParams.code,
                };
                this.getMoreData(this.tableDataUrl, data)
            }
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/voyage/VoyageResult.vue